import { useEffect, useState } from "react";
import { DEFAULT_LABEL_COLORS, DEFAULT_LABEL_FONT_COLORS } from "@utils";

export const useAdditionalColors = (list) => {
  const [additionalColors, setAdditionalColors] = useState([]);
  const [additionalFontColors, setAdditionalFontColors] = useState([]);
  
  useEffect(() => {
    setAdditionalColors(
      list.reduce((list, type) => {
        if(type.fontColor && !list.includes(type.backgroundColor) && !DEFAULT_LABEL_COLORS.includes(type.backgroundColor))
          list.push(type.backgroundColor);
        return list;
      }, [])
    )
    setAdditionalFontColors(
      list.reduce((list, type) => {
        if(type.fontColor && !list.includes(type.fontColor) && !DEFAULT_LABEL_FONT_COLORS.includes(type.fontColor))
          list.push(type.fontColor);
        return list;
      }, [])
    )
  }, []);
  
  const newAdditionalColor = (hex) => {
    if(!additionalColors.includes(hex))
      setAdditionalColors([...additionalColors, hex]);
  }
  
  const newAdditionalFontColor = (hex) => {
    if(!additionalFontColors.includes(hex))
      setAdditionalFontColors([...additionalFontColors, hex]);
  }
  
  return {
    additionalColors,
    setAdditionalColors,
    additionalFontColors,
    setAdditionalFontColors,
    onAdditionalColorAdd: newAdditionalColor,
    onAdditionalFontColorAdd: newAdditionalFontColor,
  }
}